
export const API_BASE = process.env.REACT_APP_API_BASE || '/api';
export const WS = process.env.REACT_APP_WS ||
    `${window.location.protocol === 'https:' ? 'wss' : 'ws'}://${window.location.host}/api/ws`;
